import { createContext, useContext } from "react";

/** 标记组件是否渲染在 PC 左侧栏内（用于避免主区域重复底部导航） */
export const LeftPanelContext = createContext(false);

export const useInLeftPanel = () => useContext(LeftPanelContext);
